import { createAction } from '@reduxjs/toolkit';
import { FeedId, StreamingStarted } from 'features/streaming/types';
import { UserId } from 'features/users/types';
import { ScreenshareStopped, ScreenshareStoppedRemotely } from './types';

export const localScreenshareToggled = createAction('screenshare/localScreenshareToggled');
export const localScreenshareStopped = createAction('screenshare/localScreenshareStopped');

export const bulkScreensharesClosed = createAction<UserId[]>('screenshare/bulkScreensharesClosed');

export const screenshareStarted = createAction<StreamingStarted>('signaling/screenshare/started');
export const screenshareStopped = createAction<ScreenshareStopped>('signaling/screenshare/stopped');

export const stopRemoteScreenshare = createAction<string>('signaling/screenshare/stopRemote');
export const screenshareStoppedRemotely = createAction<ScreenshareStoppedRemotely>(
  'signaling/screenshare/stoppedRemotely'
);

export const screenshareSelected = createAction<{
  feedId: FeedId;
  userId: UserId;
  whiteboardShapes?: string[];
  initial?: boolean;
  reinit?: boolean;
  update?: boolean;
  existingScreenshare?: boolean;
}>('screenshare/screenshareSelected');
